import { Avatar, Link, Stack, SxProps, Typography } from '@mui/material';
import { PurpleArrowDown } from 'Images';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';

interface IPaginationResult {
  text: string;
  onClick: Function;
  isPaginated?: boolean;
  iconSrc?: string;
  iconSx?: SxProps;
}

export const PaginationResult2 = ({
  text,
  onClick,
  isPaginated,
  iconSrc = PurpleArrowDown,
  iconSx,
}: IPaginationResult) => {
  return (
    <Link underline={'hover'}>
      <Stack
        direction='row'
        onClick={(event) => onClick(event)}
        onKeyDown={onEnterOrEscapeKeyDown}
        tabIndex={0}
        sx={{
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '8px',
          ':hover': { cursor: 'pointer' },
        }}
      >
        <Typography variant='body5'>{text}</Typography>
        <Avatar
          alt={text}
          src={iconSrc}
          sx={{
            width: '50px',
            height: '44px',
            transform: isPaginated ? 'rotate(180deg)' : undefined,
            ...iconSx,
          }}
        />
      </Stack>
    </Link>
  );
};
